'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useCallback } from 'react';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import { LEARN_MORE_URLS } from 'ads-account-connection/lib/AdAccountHelpUrls';
import H2 from 'UIComponents/elements/headings/H2';

const NoAdAccountsConnectModal = ({
  network,
  onCancel,
  onClickCreateAdAccount
}) => {
  const handleClick = useCallback(() => {
    onClickCreateAdAccount(network);
  }, [network, onClickCreateAdAccount]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onCancel
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `ADS_ACCOUNT_CONNECTION.adAccountConnectModal.noAdAccounts.header.${network}`
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `ADS_ACCOUNT_CONNECTION.adAccountConnectModal.noAdAccounts.body.${network}`
      })
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsx(UIButton, {
        external: true,
        href: LEARN_MORE_URLS[network],
        use: "primary",
        onClick: handleClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.noAdAccounts.getStarted"
        })
      })
    })]
  });
};

export default NoAdAccountsConnectModal;